import React, { useState, useEffect } from "react"
import { Link, navigate } from "gatsby"
import firebase from "gatsby-plugin-firebase"
import AuthLayout from "../../components/AuthLayout"
import { Form, Button, Input, notification } from "antd"
import "./signin.less"

const ForgotPage = ({ location }) => {
  const [formReset] = Form.useForm()
  const [formRecovery] = Form.useForm()
  const [submitting, setSubmitting] = useState(false)
  const isBrowser = typeof window !== "undefined"

  useEffect(() => {
    if (isBrowser && firebase) {
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          navigate("/backend/dashboard")
          return null
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firebase])

  const handleFormReset = async values => {
    if (isBrowser && firebase) {
      setSubmitting(true)
      try {
        const { email } = values
        await firebase
          .auth()
          .sendPasswordResetEmail(email)
          .catch(error => {
            throw error
          })

        setSubmitting(false)
        notification["success"]({
          message: "Success",
          description: "Please check your email for a password recovery link!",
          duration: 0,
        })
      } catch (error) {
        setSubmitting(false)
        console.log("Error occurred during reset ", error)
        notification["error"]({
          message: error.code || error.name || error.status,
          description: error.error_description || error.message,
          duration: 0,
        })
      }
    } else {
      notification["error"]({
        message: "Error",
        description: "Undefined window!",
        duration: 0,
      })
    }
  }
  const handleFormRecovery = async values => {
    if (isBrowser && firebase) {
      setSubmitting(true)
      try {
        const actionCode = location?.state?.code
        const { password } = values
        await firebase
          .auth()
          .verifyPasswordResetCode(actionCode)
          .then(email => {
            firebase
              .auth()
              .confirmPasswordReset(actionCode, password)
              .then(() => {
                firebase.auth().signInWithEmailAndPassword(email, password)
              })
          })
          .catch(error => {
            throw error
          })

        setSubmitting(false)
        notification["success"]({
          message: "Success",
          description: "You now login with new password.",
          duration: 0,
        })
        navigate("/")
      } catch (error) {
        setSubmitting(false)
        console.log("Error occurred during recovery ", error)
        notification["error"]({
          message: error.code || error.name || error.status,
          description: error.error_description || error.message,
          duration: 0,
        })
      }
    } else {
      notification["error"]({
        message: "Error",
        description: "Undefined window!",
        duration: 0,
      })
    }
  }

  return (
    <AuthLayout>
      <div className="pageContainer">
        {location?.state?.recovery === true ? (
          <Form
            form={formRecovery}
            layout="vertical"
            onFinish={handleFormRecovery}
          >
            <Form.Item
              name="password"
              label="กรุณากรอกรหัสผ่านใหม่"
              rules={[
                {
                  required: true,
                  message: "จำเป็นต้องกรอกข้อมูล!",
                },
                {
                  min: 6,
                  message: "ขั้นต่ำ 6 ตัวอักษร!",
                },
              ]}
              hasFeedback
            >
              <Input.Password />
            </Form.Item>
            <Form.Item shouldUpdate>
              {() => (
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                  loading={submitting}
                  disabled={
                    submitting ||
                    !formRecovery.isFieldsTouched(true) ||
                    !!formRecovery
                      .getFieldsError()
                      .filter(({ errors }) => errors.length).length
                  }
                >
                  อัพเดท
                </Button>
              )}
            </Form.Item>
          </Form>
        ) : (
          <Form form={formReset} layout="vertical" onFinish={handleFormReset}>
            <Form.Item
              name="email"
              label="กรุณากรอกอีเมลสำหรับรีเซ็ตรหัสผ่าน"
              rules={[
                {
                  required: true,
                  message: "จำเป็นต้องกรอกข้อมูล!",
                },
                {
                  type: "email",
                  message: "ที่อยู่อีเมลไม่ถูกต้อง!",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item shouldUpdate>
              {() => (
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                  loading={submitting}
                  disabled={
                    submitting ||
                    !formReset.isFieldsTouched(true) ||
                    !!formReset
                      .getFieldsError()
                      .filter(({ errors }) => errors.length).length
                  }
                >
                  รีเซ็ตรหัสผ่าน
                </Button>
              )}
            </Form.Item>
            <Form.Item style={{ margin: "0 auto", textAlign: "right" }}>
              <Link to="/auth/signin">เข้าสู่ระบบ</Link>
            </Form.Item>
          </Form>
        )}
      </div>
    </AuthLayout>
  )
}

export default ForgotPage
